export class Course {
    public id = 0
    public name = ''
    public type = 'estandar'
    public translations = ['es']
    public hours = 0
    public position = 0
    public category = 0
    public creator = 0
    public created = 0
    public locked = false
    public lockedtime = 0
    public lastexportdata = ''

    constructor() {}
}